import Drawer from 'components/presentational/Drawer';
import AvailableNumberBlocksMiniTable from '../AvailableNumberBlocksMiniTable';
import { DrawerHeader } from '@chakra-ui/react';
import CancelButton from 'components/tables/CancelButton';

const AvailableNumberBlocksDrawer = ({ isOpen, onClose, ...props }) => {
    return (
        <Drawer isOpen={isOpen} onClose={onClose}>
            <DrawerHeader>Available Number Blocks</DrawerHeader>
            <AvailableNumberBlocksMiniTable
                onDrawerClose={onClose}
                {...props}
            />
            <div className="mt-[30px]">
                <CancelButton onClick={onClose} />
            </div>
        </Drawer>
    );
};

export default AvailableNumberBlocksDrawer;
